import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 002_quotation_custom_data — Doctype Admin Epic (#347) issue B1 (#356).
//
// Adds a single nullable `custom_data` TEXT column to `sales_quotations` so
// the Custom Fields feature (A6/A7) can store per-row JSON payloads without
// requiring a schema change for every new custom field.
//
// Shape contract (enforced at the form layer by `buildCustomFieldSchema` —
// A7 helper, lives in `modules/core/services/custom-field-schema.ts`):
//   custom_data IS NULL                       → no custom fields set
//   custom_data = '{ "field_a": ..., ... }'   → field_name → primitive value
// Callers MUST read this column via `parseCustomData` so malformed blobs on
// older rows return `{}` instead of throwing.
//
// Safety:
//   - Nullable with no DEFAULT → existing rows are untouched. The DB treats
//     `ADD COLUMN X TEXT` on a pre-existing row as `NULL`, preserving data.
//   - No index added. The column is an opaque JSON blob; indexing it makes
//     no sense until someone wires a concrete extracted-field index (a B3+
//     concern, not B1 scope).
//   - `IF NOT EXISTS` is deliberately OMITTED — SQLite does not support the
//     clause for `ADD COLUMN`. Idempotence is delegated to the upstream
//     `module_migration_log` seen in `runModuleMigrations`, which skips any
//     migration whose `key` is already recorded as `completed` for this
//     company. The first attempt is authoritative.
// ============================================================================
export const migration: ModuleMigrationDef = {
  key: "002_quotation_custom_data",
  version: "1.0.0",
  sql: `
ALTER TABLE \`sales_quotations\` ADD COLUMN \`custom_data\` text;
  `.trim(),
};
